import React from 'react';
import { Link } from 'react-router-dom';

/**
 * BeeWeddy brand mark — honeycomb-heart logo + wordmark.
 * Props:
 *  - size: 'sm' | 'md' | 'lg' | 'xl' (controls logo height)
 *  - variant: 'full' (logo + wordmark) | 'logo' | 'text'
 *  - linkTo: path to link to; pass null to render without a link
 *  - className: extra classes on the outer element
 */
const SIZE_MAP = {
  sm: { img: 'h-10 w-10', text: 'text-xl' },
  md: { img: 'h-10 w-10 sm:h-14 sm:w-14', text: 'text-lg sm:text-2xl' },
  lg: { img: 'h-20 w-20', text: 'text-3xl' },
  xl: { img: 'h-28 w-28', text: 'text-4xl' },
};

const BrandLogo = ({
  size = 'md',
  variant = 'full',
  linkTo = '/',
  className = '',
  textClassName = '',
  suffix = '',
}) => {
  const s = SIZE_MAP[size] || SIZE_MAP.md;

  const content = (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      {variant !== 'text' && (
        <img
          src="/beeweddi-logo.png"
          alt="BeeWeddy"
          className={`${s.img} object-contain drop-shadow-sm`}
          data-testid="brand-logo-img"
        />
      )}
      {variant !== 'logo' && (
        <span
          className={`font-bold tracking-tight ${s.text} ${textClassName}`}
          style={{ fontFamily: "'Fredoka', 'Manrope', sans-serif", color: '#7B2CBF', letterSpacing: '-0.02em' }}
          data-testid="brand-logo-text"
        >
          BeeWeddy{suffix ? <span className="ml-2 font-semibold text-text-primary" style={{ fontFamily: "'Manrope', sans-serif" }}>{suffix}</span> : null}
        </span>
      )}
    </span>
  );

  if (linkTo) {
    return <Link to={linkTo} className="inline-flex items-center" data-testid="brand-logo">{content}</Link>;
  }
  return <span data-testid="brand-logo">{content}</span>;
};

export default BrandLogo;
